import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import { getFontSize, getFontWeight } from '../../../foundation/theme/typography.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// styled-components.
// -----------------------------------------------------------------------------
export const FormGroupExplainRoot = styled.div `
  ${({ theme }) => {
    return css `
      /* Box */
      display: flex;
      gap: ${getSpace('xs')};
      align-items: flex-start;

      /** Font */
      font-family: ${theme.typography.fontFamily};
      font-size: ${getFontSize('s')};
      font-weight: ${getFontWeight('medium')};
      line-height: 1.25;

      .fg-explain-error {
        svg {
          color: ${tokens.colors.red[500].value};
        }
      }

      .fg-explain-info {
        svg {
          color: ${tokens.colors.blue[500].value};
        }
      }

      .fg-explain-success {
        svg {
          color: ${tokens.colors.green[500].value};
        }
      }
    `;
}}
`;
//# sourceMappingURL=FormGroupExplain.styled.js.map